<div class="container">
    <div class="body-container">
        <div class="body-title-container">
            <div class="version-name" data-cy="vessel-folder-req-approval-requester-why-modal-version">
                {{ 'version.info.dialog.version-name' | translate: { version: data.versionName } }}
            </div>
            <div class="title" data-cy="vessel-folder-req-approval-requester-why-modal-header">
                {{ 'version.info.dialog.title' | translate }}
            </div>
        </div>
        <div data-cy="vessel-folder-req-approval-requester-why-modal-body">
            {{ 'version.info.dialog.text' | translate }}
        </div>
    </div>
    <div class="footer-container">
        <div class="close-button" data-cy="vessel-folder-req-approval-requester-why-modal-button" (click)="close()">
            {{ 'version.info.dialog.close.button' | translate }}
        </div>
    </div>
</div>
